import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { MdError } from 'react-icons/md'
import isNaN from 'lodash/isNaN'

import { SPACING as constants, FONTS } from '../../../constants'

import { ppsSelector } from '../../../selectors'
import { selectMode } from '../model'

const remaining_rev = 'Remaining Rev: Current Price - Actual Rev'

const tooltipData = {
  service: {
    progress_rate: 'Progress Rate: Actual / Forecast COST',
    progress_rate_1: '- COST is the sum of employee, sub-contract, and other cost',
    progress_rate_2: '- employee and sub-contract cost come from timesheet',
    progress_rate_3: '- other cost come from accounting import cost',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  vendor: {
    progress_rate: 'Progress rate: Accounting Import cost / other service forecast cost',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  hardware: {
    progress_rate: 'Progress Rate: Updated activity base in update progress',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  hardware_ma: {
    progress_rate: 'Progress Rate: Period calculation',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  license: {
    progress_rate: 'Progress Rate: Updated activity base in update progress',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  license_ma: {
    progress_rate: 'Progress Rate: Period calculation',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
  subscription: {
    progress_rate: 'Progress Rate: Revenue planning',
    actual_rev: 'Actual Rev: Current Price * Progress Rate',
    remaining_rev,
  },
}

const fallbackNaN = (number) => (isNaN(number) ? '0.00' : number)

const Layout = {
  Root: styled.div`
    --padding-top: 12px;

    height: 120px;
    width: auto;
    /* padding: calc(50px + var(--padding-top)) 16px 0; */

    /* padding-top: 50px; */
    position: relative;

    background-color: #fff;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);

    /* &::before {
      content: '${p => p.topic}';
      width: 100%;
      height: 50px;
      padding-left: ${constants.GAP};
      border: 1px solid #EAEAEA;

      display: flex;
      align-items: center;

      position: absolute;
      top: 0;
      left: 0;

      font-family: 'Gotham-Medium';
      font-size: 15px;
    } */
  `,
  Header: styled.div`
    width: 100%;
    height: 50px;
    padding-left: ${constants.GAP};
    border: 1px solid #EAEAEA;

    display: flex;
    align-items: center;
  `,
  Wrapper: styled.div`
    height: 70px;
    display: flex;
    align-items: center;
    padding: 0 16px;
  `,
  Container: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 16px;
    column-gap: 40px;
  `,
  Col: styled.div`
    display: flex;
    flex-direction: column;
  `,
  HeaderText: styled.span`
    font-family: 'Gotham-Medium';
    font-size: 15px;
  `,
  WarningCol: styled.div`
    width: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-left: 8px;

    .tooltip {
      width: max-content;
      min-width: 200px;
      max-width: 300px;
      position: absolute;
      top: 16px;
      left: 16px;
      font-family: ${FONTS.GOTHAM};
      font-size: ${FONTS.SMALL_SIZE};
      padding: 5px;
      background: #FFFFFF;
      border: 1px solid #EAEAEA;
      box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
      border-radius: 4px;
      transition: opacity 0s ease;
      opacity: 0;
      visibility: hidden;

      ul {
        margin: 0;
        padding: 8px 16px;
      }
    }

    :hover {
      .tooltip {
        transition: opacity 0s ease;
        transition-delay: 1s;
        opacity: 1;
        visibility: visible;
      }
    }
  `,
  WarningIcon: styled(MdError)`
    font-size: 20px;
    color: #C4C4C4;
  `,
}

const Revenue = {
  Title: styled.div`
    margin-bottom: 4px;

    grid-column: span 2;

    color: #333;
    font-family: 'Gotham-Bold';
    font-size: 14px;
    line-height: 16px;
  `,
  Label: styled.div`
    color: #666666;
    font-family: 'Gotham';
    font-size: 14px;
    line-height: 16px;
  `,
  Value: styled.div`
    color: #333;
    font-family: 'Notosans';
    font-weight: 800;
    font-size: 16px;
    line-height: 18px;
    padding-top: 4px;
  `,
}

/**
 * @typedef {object} Props
 * @property {object} profitData
 * @property {boolean} display
 */

/** @param {Props} props */
function RevenueCardContainer(props) {
  const { profitData, display, title, name, showMode } = props
  const mode = selectMode(display)

  const data = {
    rev: {
      progress: profitData[`$${showMode ? `${mode}_` : ''}${name}_progress_rate`],
      actual: profitData[`$${showMode ? `${mode}_` : ''}${name}_revenue_actual`],
      remaining: profitData[`$${showMode ? `${mode}_` : ''}${name}_revenue_remaining`],
    },
  }

  return (
    <Layout.Root>
      <Layout.Header>
        <Layout.HeaderText>{ title }</Layout.HeaderText>
        <Layout.WarningCol>
          <Layout.WarningIcon />
          <div className='tooltip'>
            <ul>
              <li>{tooltipData[name].progress_rate}
              {tooltipData[name].progress_rate_1 && <br/>}{tooltipData[name].progress_rate_1}
              {tooltipData[name].progress_rate_2 && <br/>}{tooltipData[name].progress_rate_2}
              {tooltipData[name].progress_rate_3 && <br/>}{tooltipData[name].progress_rate_3}
              </li>
              <li>{tooltipData[name].actual_rev}</li>
              <li>{tooltipData[name].remaining_rev}</li>
            </ul>
          </div>
        </Layout.WarningCol>
      </Layout.Header>
      <Layout.Wrapper>
        <Layout.Container>
          <Layout.Col>
            <Revenue.Label>Progress Rate</Revenue.Label>
            <Revenue.Value>{fallbackNaN(data.rev.progress)}%</Revenue.Value>
          </Layout.Col>
          <Layout.Col>
            <Revenue.Label>Actual Rev</Revenue.Label>
            <Revenue.Value>{fallbackNaN(data.rev.actual)}</Revenue.Value>
          </Layout.Col>
          <Layout.Col>
            <Revenue.Label>Remaining Rev</Revenue.Label>
            <Revenue.Value>{fallbackNaN(data.rev.remaining)}</Revenue.Value>
          </Layout.Col>
        </Layout.Container>
      </Layout.Wrapper>
    </Layout.Root>
  )
}

const mapStateToProps = createStructuredSelector({
  profitData: ppsSelector.profitData,
  display: ppsSelector.display,
})

export default connect(
  mapStateToProps,
  null
)(RevenueCardContainer)



// WEBPACK FOOTER //
// ./src/pages/project-profit-sheet/containers/RevenueCardContainer.js